import React, {useEffect, useRef, useState} from "react";
import {Button, Col, Form, Modal} from "react-bootstrap";
import PrintButton from "../PrintButton";
import PrintHeader from "../PrintHeader";
import { useTranslation } from 'react-i18next';


const ConfirmModal = ({
                          title,
                          ready,
                          description,
                          onConfirm,
                          show,
                          setShow,
                          size = "sm",
                          additionalFields,
                          alert,
                          children,
                          closable,
                          print,
                          buttonsConf,
                          modalClassName,
                          onCancel,
                          form
                      }) => {

    const { t } = useTranslation();

    const [canConfirm, setCanConfirm] = useState(true);

    const contentRef = useRef(null);

    function cancel() {
        setShow(false);
        if (onCancel) {
            onCancel();
        }
    }

    function updateSetConfirm() {
        setCanConfirm(form ? ready : true);
    }


    useEffect(updateSetConfirm, [ready]);

    function confirm() {
        setShow(false);
        if (onConfirm) {
            onConfirm();
        }
    }


    function determineConfirmTittle() {
        if (buttonsConf) {
            return buttonsConf.save
        }
        if (alert) {
            return t("common.continue");
        }

        if (form) {
            return t("common.save");
        }

        return t("common.yes");
    }

    return (
        <Modal show={show} onHide={cancel} size={size} className={modalClassName} backdropClassName={modalClassName}>
            <Modal.Header closeButton={closable !== false}>
                <Modal.Title>{title}</Modal.Title>
                {
                    print && <PrintButton title={title} contentRef={contentRef}/>
                }
            </Modal.Header>
            <Modal.Body ref={contentRef} >
                {print && <PrintHeader/>}
                {additionalFields &&
                    <Form noValidate>
                        {description &&
                            <Form.Row>
                                <Col className={"mb-3"}>
                                        {description}
                                </Col>
                            </Form.Row>
                        }
                        {additionalFields}
                    </Form>
                }

                {form ? form : ""}
                {children ? children : ""}
                {description && !additionalFields ? <>{description}</> : ""}
            </Modal.Body>
            <Modal.Footer>
                {!alert ?
                    <Button variant="light" onClick={cancel}>{buttonsConf ? buttonsConf.cancel : t("common.cancel")}</Button>
                    : ""}
                <Button variant="primary" disabled={!canConfirm} className="Modal_btn_submit"
                        onClick={confirm}>{determineConfirmTittle()}</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmModal;